<template>
  <div class="zhedang">
    <div class="baikuang" v-if="!ifshowxg">
        <div class="close" @click="close">x</div>
        <div class="tktitle">{{ ifshowmmtit }} </div>
        <div>{{alertplus==1?'TMS PLUS':'TMS'}}交易管理系统登录账号：{{ jgzh }}</div>
          <div>
            密码：{{ jgmm }}
            <div class="xhmm" @click="xgmm()">修改密码</div>
          </div>
    </div>
    <div class="baikuang" v-if="ifshowxg">
          <div @click="close" class="close">x</div>
          <div class="tktitle">修改密码</div>
          <div><span>{{alertplus==1?'TMS PLUS':'TMS'}}交易管理系统登录账号</span>{{ jgzh }}</div>
          <div>
            <span>新密码</span
            ><input
              type="password"
              v-model="newpwd"
              placeholder="请输入新密码"
            />
          </div>
          <div>
            <span>确认新密码</span
            ><input
              type="password"
              v-model="dbnewpwd"
              placeholder="请再次输入新密码"
            />
          </div>
          <div
            style="
              text-align: center;
              height: 60px;
              line-height: 60px;
              margin-bottom: 20px;
            "
          >
            <p @click="xiugaimm" class="xgbtn">修改</p>
            <p @click="fanhui" class="fhbtn">返回</p>
          </div>
        </div>
        <box v-if="box" @showbox="showbox" :message="message"></box>
  </div>
</template>

<script>
import box from './box.vue';
import axios from "axios";
import qs from "qs";
export default {
  components: { box },
    model:{
        prop:'basedata'
    },
    data(){
        return{
            ifshowxg:false,
            newzh: "", //页面文字
            newpwd: "",
            dbnewpwd: "",
            jgzh: "",
            jgmm: "",
            ifshowmmtit:'注册成功！',
            message:"",
            box:false,
        }
    },
    props:{
        basedata:[Object],
        alertplus:{
          type:[Number,String],
          default:0,
        }
    },
    methods:{
        close() {
            this.$emit("showalert", false);
        },
        showbox(x){
            this.box=x
        },
        xgmm(){
            this.ifshowxg=true
        },
        fanhui(){
            this.ifshowxg=false
        },
        xiugaimm(){
            if (this.newpwd == this.dbnewpwd) {
                var formMess = {
                gydm: this.jgzh,
                gypwd: this.newpwd,
                tmsplus:this.alertplus
                };
        axios.post("https://www.wenhua.com.cn/api/dataapi/GyxtUpdate",qs.stringify(formMess),
            {
              headers: {
                "Content-Type": "application/x-www-form-urlencoded",
              },
            }
          )
          .then((res) => {
            if (res.data.status) {
              this.close();
            }
            this.message = res.data.msg;
            this.box = true;
          });
      } else {
        this.message = "两次密码输入不一致";
        this.box = true;
      }
        }
    },
    mounted(){
        this.$nextTick(()=>{
            if (this.basedata.msg == "注册成功！") {
              this.ifshowxg = false;
              this.jgzh = this.basedata.data.gydm;
              this.jgmm = this.basedata.data.gypwd;
            } else {
              this.jgzh = this.basedata.data.gydm;
              this.jgmm = this.basedata.data.gypwd;
              this.ifshowmmtit = "该手机号已注册！";
            }
        })
    }
}
</script>

<style scoped>
.zhedang{
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0,0,0,.2);
    z-index: 3333;
}
.baikuang{
    background: #fff;
    min-height: 220px;
    width: 500px;
    position: fixed;
    top: 20%;
    left: 40%;
    text-align: center;
    border-radius: 5px;
    font-size: 15px;
}
.close{
    width: 6px!important;
    font-size: 12px;
    text-align: right!important;
    position: absolute;
    right: 10px;
    top: -6px;
    cursor: pointer;
}
.baikuang div{
    width: 400px;
    margin: 0 auto;
    text-align: left;
    line-height: 38px;
}
.tktitle{
    margin-top: 30px!important;
    font-size: 18px;
    height: 40px;
    line-height: 40px;
    border-bottom: 1px solid #848484;
    margin-bottom: 15px;
}
.baikuang input {
  width: 196px;
  height: 28px;
  line-height: 28px;
  border: 1px solid rgb(137, 137, 137);
  color: rgb(121, 121, 121);
  font-size: 15px;
  padding: 0px 10px;
}
.baikuang div span {
  display: inline-block;
  width: 150px;
  text-align: right;
  margin-right: 10px;
}
.xhmm {
  cursor: pointer;
  color: blue;
  text-decoration: underline;
  width: 100px !important;
  display: inline-block;
}
.close {
  width: 6px !important;
  font-size: 12px;
  text-align: right !important;
  position: absolute;
  right: 10px;
  top: -6px;
  cursor: pointer;
}
.xgbtn {
  width: 100px;
  height: 28px;
  line-height: 28px;
  text-align: center;
  background-color: rgb(68, 141, 243);
  border-radius: 3px;
  border: none;
  color: rgb(255, 255, 255);
  letter-spacing: 2px;
  margin-left: 60px !important;
}
.fhbtn {
  text-decoration: underline;
  height: 28px;
  line-height: 28px;
}
.baikuang div p{
    cursor: pointer;
    display: inline-block;
    margin: 0 5px;
}
</style>